export default __webpack_public_path__ + "static/media/logoMb.fb0ecc49.png";